module.exports = __webpack_public_path__ + "img/zen-pond.9593d514.webp";